import {
    SET_INSTRUCTOR_OFFERINGS,
    ADD_INSTRUCTOR_OFFERING,
    DELETE_INSTRUCTOR_OFFERING,
    UPDATE_INSTRUCTOR_OFFERING,
} from 'store/reducers/instructorReducer'
import moment from 'moment-timezone'
import {apiRequest} from 'util/api/util';
import { snapshotToObjects } from 'util/firestore';
import {buildHeaders} from 'util/api/CheckoutAPI'
import { compareOfferings } from 'lib/offerings';
const BASE_URL = process.env.REACT_APP_APP_BASE_URL;
const OFFERINGS_COLLECTION = process.env.REACT_APP_OFFERINGS_COLLECTION


export const loadOfferings = () => (dispatch, getState, { getFirestore }) => {
    // TODO: consider passing partnerId to mitigate race condition
    const partnerId = getState().instructor.instructor.platformID;
    const db = getFirestore();
    const partnerRef = db.collection("users").doc(partnerId);
    const offeringsRef = partnerRef.collection(OFFERINGS_COLLECTION);
    const metaRef = partnerRef.collection("meta").doc("offerings");

    return offeringsRef.get().then(snapshot => {
        // Get offerings metadata document, which contains the order, and
        // then retrieve the offerings themselves and apply the ordering
        metaRef.get().then(doc => {
            const order = doc.exists ? doc.data().order ?? [] : [];
            const offerings = snapshotToObjects(snapshot);

            for (let i = 0; i < offerings.length; i++) {
                // look up position of this id in the ordering array and set the
                // private _ordinal property if it exists
                const oid = offerings[i].id;
                const ii = order.indexOf(oid);
                if (ii < 0) {
                    delete offerings[i]._ordinal;
                } else {
                    offerings[i]._ordinal = ii;
                }
            }
            offerings.sort(compareOfferings);

            dispatch({ type: SET_INSTRUCTOR_OFFERINGS, offerings });
        });
    });
};

export const deleteOffering = (offering) => {
    return (dispatch, getState, { getFirebase, getFirestore }) => {
        // const state = getState()
        // const partnerId = state.instructor.instructor.platformID
        const db = getFirestore()

        offering = {
            ...offering,
            active: false,
            deleted: true
        }

        return db.collection("users").doc(offering.partnerId)
            .collection(OFFERINGS_COLLECTION).doc(offering.id)
            .set({
                active: false,
                deleted: true
            }, {merge: true})
            .then(res => {
                // dispatch({type: DELETE_INSTRUCTOR_OFFERING, offering: offering})
                dispatch({type: UPDATE_INSTRUCTOR_OFFERING, offering: offering})
                return res
            })
    }
}

export const saveOffering = (offering) => {
    return (dispatch, getState, { getFirebase, getFirestore }) => {

        const state = getState()

        offering = {
            ...offering,
            partnerId: state.instructor.instructor.platformID,
            deleted: false
        }

        offering.partnerId = state.instructor.instructor.platformID
        offering.deleted = false

        if (offering.id) { // update
            //
            offering.updated = moment().unix()
            return buildHeaders()
                .then(headers => {
                    return fetch(`${BASE_URL}/app/offering?offeringId=${offering.id}`, {
                        method: 'PUT',
                        headers: headers,
                        body: JSON.stringify({
                            offering: offering
                        })
                    })
                })
                .then(response => {
                    return response.json()
                })
                .then(json => {
                    if (json.offering) {
                        dispatch({type: UPDATE_INSTRUCTOR_OFFERING, offering: offering})
                    }
                    return json
                })
        } else { // add new
            offering.created = moment().unix()
            return buildHeaders()
                .then(headers => {
                    return fetch(`${BASE_URL}/app/offering`, {
                        method: 'POST',
                        headers: headers,
                        body: JSON.stringify({
                            offering: offering
                        })
                    })
                })
                .then(response => {
                    return response.json()
                })
                .then(json => {
                    console.log("offering response")
                    // console.log(response)
                    console.log(json)
                    if (json.offering) {
                        dispatch({type: ADD_INSTRUCTOR_OFFERING, offering: json.offering})
                    }
                    return json
                })
        }
    }
}

export const setOfferingOrder = offerings => dispatch => {

    if (!Array.isArray(offerings)) {
        console.error("setOfferOrder expects an array of offerings, got", offerings);
        return;
    }

    if (offerings.length < 1) return;

    const data = {
        partnerId: offerings[0].partnerId,
        order: offerings.map(o => o.id),
    }

    apiRequest("app/offering/meta", "POST", data)
        .then(resp => {
            console.log("setting offering order and reloading", resp);
            dispatch(loadOfferings());
        })
        .catch(message => {
            console.log("error setting offering order", message);
        });
};

